import React from 'react';
import './FilieresPage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { toSentenceCase } from '../utils/textUtils';
import useSEO from '../hooks/useSEO';

function FilieresPage() {
  useSEO({
    title: "Pôles & Formations | Enseignement Général, Technique & Professionnel",
    description: "Explorez nos filières d'excellence à Togba (Abomey-Calavi) : Enseignement Général (CPEG A, B, C, D), Technique & Gestion (CPET G1, G2, G3, F3, F4) et Métiers d'Avenir (CPFPA / ISP).",
    keywords: "filières GSU Les Palmiers, BAC G2 Calavi, BAC F4 Génie Civil Bénin, formation électrotechnique Togba, CPEG Les Palmiers, CPET Les Palmiers, formations professionnelles Abomey-Calavi",
    canonicalUrl: "https://gsulespalmiers.bj/filieres"
  });

  const handleInscription = () => {
    if (window.navigateTo) {
      window.navigateTo('student-registration');
      window.scrollTo(0, 0);
    }
  };

  const filieres = [
    {
      id: 'genie-civil',
      name: 'Génie Civil',
      code: 'F4 / BTP',
      description: 'Formation pratique aux techniques du bâtiment, des travaux publics et des infrastructures. Préparez-vous à contribuer au développement des villes et des chantiers modernes.',
      diplomes: ['CAP BTP', 'BAC F4', 'BTS Génie Civil'],
      debouches: ['Conducteur de travaux', 'Métreur', 'Chef de chantier', 'Ingénieur BTP', 'Entrepreneur en construction'],
      icon: <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 21h18M9 8h1m0 0h1m-1 0v12m0-12V6l7-3v18"/><path d="M14 8h1m0 0h1m-1 0v12"/></svg>,
      color: '#3b82f6'
    },
    {
      id: 'electrotechnique',
      name: 'Électrotechnique',
      code: 'F3',
      description: 'Maîtrisez l\'électricité industrielle et domestique, les installations et la maintenance. Une filière indispensable pour travailler dans l\'énergie et les systèmes électriques.',
      diplomes: ['CAP Électricité', 'BAC F3', 'BTS Électrotechnique'],
      debouches: ['Électricien industriel', 'Technicien maintenance', 'Installateur électrique', 'Chef d\'équipe électricité'],
      icon: <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>,
      color: '#f59e0b'
    },
    {
      id: 'informatique',
      name: 'Informatique',
      code: 'IMI',
      description: 'Initiez-vous aux bases de l\'informatique, du développement logiciel et de la maintenance des systèmes. Une filière tournée vers les nouvelles technologies et l\'innovation.',
      diplomes: ['CAP Informatique', 'BAC G2 IMI', 'BTS Informatique'],
      debouches: ['Développeur web', 'Technicien réseau', 'Administrateur système', 'Analyste programmeur'],
      icon: <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>,
      color: '#10b981'
    },
    {
      id: 'mode-vetement',
      name: 'Métiers de la Mode & du Vêtement',
      code: 'MM-V',
      description: 'Apprenez la création et la confection de vêtements modernes et traditionnels, du stylisme à la couture professionnelle. Une filière qui ouvre la voie vers la mode et l\'entrepreneuriat.',
      diplomes: ['CAP Couture', 'BAC MM-V', 'BTS Mode'],
      debouches: ['Styliste', 'Couturier', 'Modéliste', 'Chef d\'atelier couture', 'Entrepreneur mode'],
      icon: <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.38 3.46L16 2a4 4 0 01-8 0L3.62 3.46a2 2 0 00-1.34 2.23l.58 3.47a1 1 0 00.99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 002-2V10h2.15a1 1 0 00.99-.84l.58-3.47a2 2 0 00-1.34-2.23z"/></svg>,
      color: '#ec4899'
    },
    {
      id: 'hotellerie-restauration',
      name: 'Hôtellerie & Restauration',
      code: 'HR',
      description: 'Formation pratique aux métiers de la cuisine, du service et de la gestion hôtelière. Préparez-vous à intégrer les restaurants et hôtels de référence, au Bénin et à l\'international.',
      diplomes: ['CAP Cuisine', 'BAC HR', 'BTS Hôtellerie'],
      debouches: ['Chef cuisinier', 'Serveur', 'Réceptionniste', 'Manager hôtelier', 'Entrepreneur restauration'],
      icon: <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 002-2V2M7 2v20M21 15V2v0a5 5 0 00-5 5v6c0 1.1.9 2 2 2h3zm0 0v7"/></svg>,
      color: '#ef4444'
    },
    {
      id: 'comptabilite-gestion',
      name: 'Comptabilité & Gestion',
      code: 'G2 / CoM',
      description: 'Maîtrisez les principes de la comptabilité, de la gestion et de l\'administration. Une filière qui ouvre les portes des banques, entreprises et cabinets de gestion.',
      diplomes: ['CAP Comptabilité', 'BAC G2', 'BTS Comptabilité'],
      debouches: ['Comptable', 'Gestionnaire', 'Contrôleur de gestion', 'Auditeur', 'Conseiller financier'],
      icon: <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 3v18h18"/><path d="M18 17V9M13 17V5M8 17v-3"/></svg>,
      color: '#8b5cf6'
    },
    {
      id: 'mecanique-automobile',
      name: 'Mécanique Automobile',
      code: 'MA',
      description: 'Apprenez la maintenance, la réparation et la gestion technique des véhicules modernes. Une filière pour devenir mécanicien qualifié ou entrepreneur dans le domaine automobile.',
      diplomes: ['CAP Mécanique', 'BAC MA', 'BTS Automobile'],
      debouches: ['Mécanicien auto', 'Électricien auto', 'Chef d\'atelier', 'Contrôleur technique', 'Garagiste'],
      icon: <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>,
      color: '#64748b'
    },
    {
      id: 'tourisme',
      name: 'Tourisme',
      code: 'Tour',
      description: 'Découvrez les métiers du tourisme et de l\'accueil. Formation aux techniques d\'animation, de guidage et de promotion touristique.',
      diplomes: ['CAP Tourisme', 'BAC Tourisme', 'BTS Tourisme'],
      debouches: ['Guide touristique', 'Agent de voyage', 'Animateur', 'Réceptionniste', 'Promoteur touristique'],
      icon: <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 000 20 14.5 14.5 0 000-20M2 12h20"/></svg>,
      color: '#06b6d4'
    },
    {
      id: 'operateur-geometre',
      name: 'Opérateur Géomètre',
      code: 'OG',
      description: 'Formation aux techniques de mesure et de cartographie. Apprenez à utiliser les instruments de topographie moderne.',
      diplomes: ['CAP Topographie', 'BAC OG', 'BTS Géomètre'],
      debouches: ['Géomètre', 'Topographe', 'Cartographe', 'Arpenteur', 'Technicien cadastre'],
      icon: <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>,
      color: '#84cc16'
    },
    {
      id: 'dev-web-mobile',
      name: 'Développement Web & Mobile',
      code: 'DWM',
      description: 'Maîtrisez les technologies web et mobile modernes. Formation aux langages de programmation et aux frameworks actuels.',
      diplomes: ['CAP Informatique', 'BAC DWM', 'BTS Développement'],
      debouches: ['Développeur web', 'Développeur mobile', 'Webmaster', 'UI/UX Designer', 'Chef de projet digital'],
      icon: <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="5" y="2" width="14" height="20" rx="2"/><path d="M12 18h.01"/></svg>,
      color: '#f97316'
    },
    {
      id: 'secretariat',
      name: 'Secrétariat',
      code: 'AC/EL',
      description: 'Formez-vous aux techniques administratives, à la communication et à la gestion de dossiers. Une filière qui prépare aux métiers de l\'assistanat et du secrétariat professionnel.',
      diplomes: ['CAP Secrétariat', 'BAC AC/EL', 'BTS Assistanat'],
      debouches: ['Secrétaire', 'Assistant(e) de direction', 'Chargé(e) d\'accueil', 'Gestionnaire administratif'],
      icon: <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/></svg>,
      color: '#a855f7'
    }
  ];

  return (
    <div className="filieres-page">
      <Header activePage="filieres" />
      
      {/* Hero Section */}
      <section className="filieres-hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">{toSentenceCase("Nos Filières de Formation")}</h1>
            <p className="hero-description">
              {toSentenceCase("Découvrez des formations adaptées aux besoins du marché et aux ambitions des apprenants.")}
            </p>
          </div>
        </div>
      </section>

      {/* Filières Grid */}
      <section className="filieres-section">
        <div className="container">
          <div className="filieres-grid">
            {filieres.map((filiere) => (
              <div key={filiere.id} className="filiere-card" style={{'--filiere-color': filiere.color}}>
                <div className="filiere-header">
                  <div className="filiere-icon">{filiere.icon}</div>
                  <div className="filiere-title-section">
                    <h3 className="filiere-name">{filiere.name}</h3>
                    <span className="filiere-code">({filiere.code})</span>
                  </div>
                </div>
                
                <p className="filiere-description">{filiere.description}</p>
                
                <div className="filiere-details">
                  <div className="detail-section">
                    <h4>Diplômes</h4>
                    <ul className="detail-list">
                      {filiere.diplomes.map((diplome, index) => (
                        <li key={index}>{diplome}</li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="detail-section">
                    <h4>Débouchés</h4>
                    <ul className="detail-list">
                      {filiere.debouches.slice(0, 3).map((debouche, index) => (
                        <li key={index}>{debouche}</li>
                      ))}
                      {filiere.debouches.length > 3 && (
                        <li className="more-items">+{filiere.debouches.length - 3} autres...</li>
                      )}
                    </ul>
                  </div>
                </div>
                
                <button 
                  className="filiere-cta"
                  onClick={handleInscription}
                >
                  {toSentenceCase("S'inscrire maintenant")}
                </button>
              </div>
            ))}
          </div>
          
          {/* CTA Global */}
          <div className="global-cta">
            <div className="cta-content">
              <h2>{toSentenceCase("Prêt à rejoindre l'excellence ?")}</h2>
              <p>{toSentenceCase("Choisissez votre filière et commencez votre parcours vers la réussite professionnelle.")}</p>
              <button 
                className="btn-cta-main"
                onClick={handleInscription}
              >
                <span>{toSentenceCase("Inscris-toi maintenant")}</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default FilieresPage;
